import { Tooltip } from "@zapier/design-system-beta";
import { Icon } from "@zapier/zinnia-icons";
import { useAtomValue } from "jotai";
import { selectedNodeTypeAtom } from "@zapier/canvas-state";
import classNames from "classnames";

import styles from "./DiagrammingToolbar.module.css";
import { useSelectNodeType } from "./useSelectNodeType";

type Props = {
  isDisabled: boolean;
};

const logoNames = {
  canvasLogoName: "navCanvas",
  tablesLogoName: "navTables",
  interfacesLogoName: "navInterfaces",
  chatbotsLogoName: "navAIChatbot",
} as const;

export function AppNodeOptions({ isDisabled }: Props) {
  const selectedNodeType = useAtomValue(selectedNodeTypeAtom);
  const { maybeSelectNodeType } = useSelectNodeType();

  const { tablesLogoName, interfacesLogoName, chatbotsLogoName } = logoNames;
  const listItemClass = isDisabled
    ? `${styles.dndnode} ${styles.dndnodeDisabled}`
    : styles.dndnode;

  return (
    <ul className={styles.horizontalList}>
      <li
        className={classNames(listItemClass, {
          [styles.dndnodeSelected]: selectedNodeType === "zap",
        })}
      >
        <Tooltip placement="top" content={isDisabled ? "" : "Zap"}>
          <Tooltip.FocusableTrigger>
            <button
              aria-label="Add Zap step"
              className={styles.dndButton}
              disabled={isDisabled}
              onClick={() => {
                maybeSelectNodeType("zap");
              }}
              onKeyDown={() => {
                maybeSelectNodeType("zap");
              }}
            >
              <Icon size={28} color="BrandOrange" name="miscBoltAltFill" />
            </button>
          </Tooltip.FocusableTrigger>
        </Tooltip>
      </li>
      <li
        className={classNames(listItemClass, {
          [styles.dndnodeSelected]: selectedNodeType === "table",
        })}
      >
        <Tooltip placement="top" content={isDisabled ? "" : "Table"}>
          <Tooltip.FocusableTrigger>
            <button
              aria-label="Add table step"
              className={styles.dndButton}
              disabled={isDisabled}
              onClick={() => {
                maybeSelectNodeType("table");
              }}
              onKeyDown={() => {
                maybeSelectNodeType("table");
              }}
            >
              <Icon size={28} color="BrandOrange" name={tablesLogoName} />
            </button>
          </Tooltip.FocusableTrigger>
        </Tooltip>
      </li>
      <li
        className={classNames(listItemClass, {
          [styles.dndnodeSelected]: selectedNodeType === "interface",
        })}
      >
        <Tooltip placement="top" content={isDisabled ? "" : "Interface"}>
          <Tooltip.FocusableTrigger>
            <button
              aria-label="Add interface step"
              className={styles.dndButton}
              disabled={isDisabled}
              onClick={() => {
                maybeSelectNodeType("interface");
              }}
              onKeyDown={() => {
                maybeSelectNodeType("interface");
              }}
            >
              <Icon size={28} color="BrandOrange" name={interfacesLogoName} />
            </button>
          </Tooltip.FocusableTrigger>
        </Tooltip>
      </li>
      <li
        className={classNames(listItemClass, {
          [styles.dndnodeSelected]: selectedNodeType === "chatbots",
        })}
      >
        <Tooltip placement="top" content={isDisabled ? "" : "Chatbots"}>
          <Tooltip.FocusableTrigger>
            <button
              aria-label="Add chatbots step"
              className={styles.dndButton}
              disabled={isDisabled}
              onClick={() => {
                maybeSelectNodeType("chatbots");
              }}
              onKeyDown={() => {
                maybeSelectNodeType("chatbots");
              }}
              draggable={!isDisabled}
            >
              <Icon size={28} color="BrandOrange" name={chatbotsLogoName} />
            </button>
          </Tooltip.FocusableTrigger>
        </Tooltip>
      </li>
    </ul>
  );
}
